import React, { Component } from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import SearchFilters from './SearchFilters';
import EventsEmpty from './Empty';

import { Link } from 'react-router-dom';
import { Role } from '../../../_helpers/role';
import { connect } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { eventService } from '../../../_services/event.service';
import { Button, Spinner } from 'react-bootstrap';
import { Can } from '../../../_contexts/AbilitiesContext';

const columns = [
  {
    name: 'Event Status',
    sort: false,
    cell: row => {
      return <span className='badge badge-info text-uppercase'>{row.status}</span>
    }
  },
  {
    name: 'Event Type',
    sort: false,
    cell: row => {
      return <span className='badge badge-info text-uppercase'>{
        `${row.type.slice(0, 25)}${row.type.length > 25 ? '...' : ''}`
      }</span>
    }
  },
  {
    name: 'Event Date',
    sort: false,
    cell: row => {
      if (row.date && row.time) {
        return moment.tz(`${row.date}T${row.time}`, row.providerGroup.timezone)
          .local()
          .format('l LT')
      } else {
        return moment.tz(`${row.date}`, row.providerGroup.timezone).local().format('l')
      }
    }
  },
  {
    name: 'Patient Name',
    sort: false,
    cell: row => {
      if (row.userProfile) {
        return `${row.userProfile.firstName} ${row.userProfile.lastName}`
      } else {
        return `${row.patientFirstName} ${row.patientLastName}`
      }
    }
  },
  {
    name: 'Provider',
    sort: false,
    cell: row => `${row.doctor.firstName} ${row.doctor.lastName}`
  },
  {
    name: 'Location',
    sort: false,
    cell: row => row.providerGroup.name
  },
  {
    button: true,
    width: '125px',
    sort: false,
    cell: row => <Link className="btn btn-outline-primary btn-sm" to={`/events/${row.id}/details`}>Details</Link>
  }
];

class List extends Component {

  constructor(props) {
    super(props);

    this.state = {
      total: null,
      events: [],
      initLoad: true,
      isLoading: false
    }

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    const { currentUser } = this.props;

    if (currentUser.UserType.Name === 'Licensed') {
      const providerId = currentUser.Doctor.DoctorId;
      this.props.history.push(`/events?professional=${providerId}&time=${Date.now()}`)
    } else {
      this.loadData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.loadData();
    }
  }

  loadData() {
    const searchParams = this.searchParams();

    this.setState({ isLoading: true });

    eventService.getEvents(searchParams)
      .then(response => {
        if (this.state.initLoad && response.collection.data.length > 0) {
          this.setState({ initLoad: false })
        }
        this.setState({
          total: response.total,
          events: response.collection.data,
          isLoading: false
        })
      })
      .catch(() => {
        this.setState({ isLoading: false })

        this.props.dispatch(alertActions.error('Could not retrieve events at this time. Please try again.'))
      })
  }

  searchParams() {
    const queryParams = queryString.parse(this.props.location.search);
    const showDateRange = ("eventStartDate" in queryParams) ? true : false;

    return {
      page: queryParams.page || 1,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
      date: !showDateRange ? queryParams.date || '' : '',
      eventStartDate: showDateRange ? queryParams.eventStartDate || '' : '',
      eventEndDate: showDateRange ? queryParams.eventEndDate || '' : '',
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      eventType: queryParams.eventType ? parseInt(queryParams.eventType) : '',
    }
  }

  render() {
    const { isLoading, total } = this.state;

    const urlParams = this.searchParams();

    return (
      <div className="row">
        <div className="col-lg-10 offset-lg-2">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="h2"><i className="far fa-calendar-alt" aria-hidden="true"></i> Events</h1>
            </div>

            <Can I="schedule" an="events">
              <div className="col-lg-6 text-right">
                <Button
                  as={Link}
                  to="/events/schedule"
                  variant="primary"
                  className="px-5">Schedule Event
                </Button>
              </div>
            </Can>

          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-2">
              <SearchFilters location={this.props.location} handleSearch={(params) => {
                const { firstName, lastName, dateOfBirth, date, eventStartDate, eventEndDate, location, professional, eventType, showDateRange } = params;

                const startDate = eventStartDate ? moment(eventStartDate).format("L") : '';
                const endDate = eventEndDate ? moment(eventEndDate).format("L") : '';

                this.props.history.replace(`/events?firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}${showDateRange ? `&eventStartDate=${startDate}&eventEndDate=${endDate}` : `&date=${date}`}&location=${location}&professional=${professional}&eventType=${eventType}`)
              }} />
            </div>
            <div className="col-lg-10">
              {this.state.initLoad && isLoading ?
                <Spinner animation="border" role="status" />
                :
                this.state.initLoad && this.state.events.length === 0 ?
                  <EventsEmpty />
                  :
                  <DataTable
                    data={this.state.events}
                    columns={columns}
                    progressPending={isLoading}
                    onChangePage={page => {
                      const queryParams = queryString.parse(this.props.location.search);
                      const showDateRange = ("eventStartDate" in queryParams) ? true : false;

                      const firstName = queryParams.firstName || '';
                      const lastName = queryParams.lastName || '';
                      const dateOfBirth = queryParams.dateOfBirth || '';
                      const date = queryParams.date || '';
                      const eventStartDate = queryParams.eventStartDate || '';
                      const eventEndDate = queryParams.eventEndDate || '';
                      const location = queryParams.location ? parseInt(queryParams.location) : '';
                      const professional = queryParams.professional ? parseInt(queryParams.professional) : '';
                      const eventType = queryParams.eventType ? parseInt(queryParams.eventType) : '';

                      this.props.history.replace(`/events?page=${page}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}${showDateRange ? `&eventStartDate=${eventStartDate}&eventEndDate=${eventEndDate}` : `&date=${date}`}&location=${location}&professional=${professional}&eventType=${eventType}`)
                    }}
                    noHeader={true}
                    striped={true}
                    pagination={true}
                    paginationServer={true}
                    paginationTotalRows={total}
                    paginationRowsPerPageOptions={[15]}
                    paginationPerPage={15}
                    paginationDefaultPage={parseInt(urlParams.page)}
                    noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
                    customStyles={{ cells: { style: { fontSize: '14px' }, }, }}

                  />
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}
function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps)(List);